export default __webpack_public_path__ + "static/media/i3.917af48d.png";